import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    armed: String,                              // class added on connect (animation start state)
    in: String,                                 // class added once the element scrolls into view
    threshold: { type: Number, default: 0.3 },
  }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.element.classList.add(this.armedValue)
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: this.thresholdValue })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  onIntersect(entries) {
    if (!entries.some((entry) => entry.isIntersecting)) return

    this.observer.disconnect()
    this.element.classList.add(this.inValue)
  }
}
